import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { InfraEndPointModel } from '../models/infraEndPoint.model';
import { PbiWorkSpaceModel } from '../models/pbiWorkSpace.model';
import { UserModel } from '../models/user.model';
import { InfraService } from './infra.service';
import { Observable } from 'rxjs';

@Injectable()
export class PbiWorkSpaceService {
  private configCoreEngagementUrl: string;
  private configUrl: string;

  funcId: any;
  intervalTime: number = 30000;  // Interval time in nano seconds
  private httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Basic ' + btoa(':3qrxhrv4sxjsmgxfx45cf4pza2d247ttxfftw4rvi5jonwj2pu7a') }) };
  private infraDetails: InfraEndPointModel;
  private coreAPIDownloadUploadUrl: string;
  private logOutCoreUrl: string;
  constructor(private infraService: InfraService, private http: HttpClient) {

    this.infraService.infraDetails$.subscribe((data: InfraEndPointModel) => {
      this.infraDetails = data;
      this.configUrl = data.WebEndPoint2 + 'powerbi';
      this.configCoreEngagementUrl = data.WebEndPoint2 + 'PowerBi';
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra')) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }
  }

  public createWorkSpaceQueue(workspaceData: PbiWorkSpaceModel) {
    const payloadWS = {
      "environment": workspaceData.environment,
      "location": workspaceData.location,
      "pbiworkspace": workspaceData.pbiworkspace,
      "pbiworkspacedestroy": workspaceData.pbiworkspacedestroy,
      "pbiworkspaceName": workspaceData.pbiworkspaceName,
      "userEmails": workspaceData.userEmails,
      "Access": workspaceData.Access,
      "addremove": workspaceData.addremove,
      "workspaceName": workspaceData.workspaceName,
      "requestedby": workspaceData.requestedby
    };
    return this.http.post(`${this.configUrl}/insertWorkSpaceQueue`, payloadWS).toPromise();
  }

  public DeleteWorkSpaceQueue(workspaceData: PbiWorkSpaceModel) {
    const payloadWS = {
      "environment": workspaceData.environment,
      "location": workspaceData.location,
      "pbiworkspace": workspaceData.pbiworkspace,
      "pbiworkspacedestroy": workspaceData.pbiworkspacedestroy,
      "pbiworkspaceName": workspaceData.pbiworkspaceName,
      "userEmails": workspaceData.userEmails,
      "Access": workspaceData.Access,
      "addremove": workspaceData.addremove,
      "workspaceName": workspaceData.workspaceName,
      "requestedby": workspaceData.requestedby
    };
    return this.http.post(`${this.configUrl}/deleteWorkSpaceQueue`, payloadWS);
  }

  public addUser(workspaceData: PbiWorkSpaceModel) {
    const payloadWSUser = {
      "requesttype": "User",
      "environment": workspaceData.environment,
      "location": workspaceData.location,
      "workspaceName": workspaceData.workspaceName,
      "userEmails": workspaceData.userEmails,
      "Access": workspaceData.Access,
      "addremove": workspaceData.addremove,
      "requestedby": workspaceData.requestedby
    };
    return this.http.post(`${this.configUrl}/addUser`, payloadWSUser).subscribe((data: any) => {
      console.log('Add user data:', data);
    });
  }


  public deleteUser(workspaceData: PbiWorkSpaceModel) {
    const payloadWSUser = {
      "requesttype": "User",
      "environment": workspaceData.environment,
      "location": workspaceData.location,
      "workspaceName": workspaceData.workspaceName,
      "userEmails": workspaceData.userEmails,
      "Access": workspaceData.Access,
      "addremove": workspaceData.addremove,
      "requestedby": workspaceData.requestedby
    };
    return this.http.post(`${this.configUrl}/deleteUser`, payloadWSUser);
  }


}
